// Environment configuration
console.log('=== ENVIRONMENT VARIABLES DEBUG ===');
console.log('All env vars:', process.env);
console.log('REACT_APP_SUPABASE_URL:', process.env.REACT_APP_SUPABASE_URL);
console.log('REACT_APP_SUPABASE_ANON_KEY:', process.env.REACT_APP_SUPABASE_ANON_KEY);
console.log('URL type:', typeof process.env.REACT_APP_SUPABASE_URL);
console.log('KEY type:', typeof process.env.REACT_APP_SUPABASE_ANON_KEY);

if (!process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.error("REACT_APP_SUPABASE_ANON_KEY is missing!");
  alert("REACT_APP_SUPABASE_ANON_KEY is required");
  throw new Error("REACT_APP_SUPABASE_ANON_KEY is required");
}
if (!process.env.REACT_APP_SUPABASE_URL) {
  console.error("REACT_APP_SUPABASE_URL is missing!");
  alert("REACT_APP_SUPABASE_URL is required");
  throw new Error("REACT_APP_SUPABASE_URL is required");
}

export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

